// extracted by mini-css-extract-plugin
export var box = "_3q-1";
export var checkboxRow = "_3q-8";
export var checked = "_3q-2";
export var descriptionSpacer = "_3q-a";
export var disabled = "_3q-3";
export var icon = "_3q-6";
export var input = "_3q-0";
export var labelSpacer = "_3q-9";
export var medium = "_3q-5";
export var small = "_3q-4";
export var text = "_3q-7";